<template>
  <p>
    El radar Radar de aire limpio y Estimación de Lluvia (Clear-Air and Rainfall
    Estimation radar, CLAIRE) es un radar cuasi-monoestático que opera a 445 MHz
    (l50,67 m) con una anchura de haz de 9.46° y consta de una antena
    transmisora Tenna y tres conjuntos de antenas receptoras. El sistema tiene
    una resolución vertical de hasta 75 m, que cubre desde 750 m hasta 8 km
    sobre la superficie. Tiene una potencia de transmisión de tipo estado sólido
    de 5 kW.
  </p>

  <p>
    El CLAIRE es de fabricación nacional, diseñado y construido por personal del
    Radio Observatorio de Jicamarca del IGP con el objetivo de estudiar la
    turbulencia y precipitación que ayudan a analizar y cuantificar los
    fenómenos meteorológicos. El CLAIRE es capaz de estimar los componentes
    tridimensionales del viento (zonal, meridional y vertical), ecos de
    turbulencia utilizando el análisis espectral (FSA; Briggs y Vincent 1992) y
    estimación de la intensidad de lluvia.
  </p>

  <img
    class="thumbnail instrument"
    src="@/assets/images/microfisica/instrumentos/radar-claire.webp"
    alt="Radar CLAIRE"
  />

  <p>
    <b>
      Variables más importantes que registra:
    </b>
  </p>
  <List marked>
    <li>Reflectividad (dBZ)</li>
    <li>Velocidad Radial (m/s)</li>
  </List>

  <p>
    <b>Datos disponibles en: </b> <br />
    <a
      href="https://www.igp.gob.pe/observatorios/radio-observatorio-jicamarca/realtime/plot/172/rti/"
      target="_blank"
      >https://www.igp.gob.pe/observatorios/radio-observatorio-jicamarca/realtime/plot/172/rti/</a
    >
  </p>

  <p>
    <b>País: </b> <br />
    Perú.
  </p>

  <p>
    <b>Responsable: </b> <br />
    jespinoza@igp.gob.pe
  </p>
</template>

<script>
import List from "@/components/ui/objects/List";
export default {
  components: { List },
};
</script>
